import React, { useEffect, useState, Suspense } from "react";
import Sidebar from "./../../Common/Sidebar";
import { TabContent, TabPane } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { MainTabsComponent } from "./MainTabsObj";
import { activeMainTab, swtichTab } from "../../Redux/TabsSlice/TabsSlice";
import { UpdatePracticePopupAction, refreshToken, userAuthAction, } from "../../Redux/UserAuthSlice/UserAuthSlice";
import GlobalNavigation from "../../Common/GlobalNavigationObj";
import Header from "../../Common/Header/Header";
import FallBackLoader from "Common/FallBackLoader";
import { motion } from "framer-motion";
import ConfirmationPopup from "Popups/ConfirmationPopup/ConfirmationPopup";
import api from "http";
import { ErrorHandlingMessage } from "Utils/ErrorHandlingMessage";
import RightsWrapper from "./RightsWrapper";
import { lowercaseKeys } from "Utils/Utils";
import useIdleTimeout from "CustomHooks/useIdleTimeout";
import IdleTimeoutpopup from "Popups/IdleTimeoutPopup/IdleTimeoutPopup";
import useShortcutKeys from "CustomHooks/useShortcutKeys";
import Show from "Components/Show/Show";
import { toggleClaimPopup } from "Redux/PopupSlice/PopupSlice";
import CreateNewClaimPopup from "Popups/CreateNewClaimPopup/CreateNewClaimPopup";
import NoAccessScreen from "Components/NoAccessScreen/NoAccessScreen";
import FullPageLoader from "Components/FullPageLoader/FullPageLoader";
import HoverRevealScrollbarWrapper from "Components/HoverRevealScrollbarWrapper/HoverRevealScrollbarWrapper";

const mainTabItemsList = GlobalNavigation;
const CURRENT_TAB = 0;

const HomePage = () => {
  const { mainTab } = useSelector((state) => state.tabs);
  // const sidebar = useSelector(sidebarSelector);
  const [sidebarToggle, setSidebarToggle] = useState(true);
  const dispatch = useDispatch();
  const { tabsModal, activeTab } = useSelector(state => ({ tabsModal: state.tabs.tabsModal, activeTab: state.tabs.activeTab }))
  const [loader, setLoader] = useState(false)
  const { userinfo, practicePopup } = useSelector((state) => state.userAuth);
  const rawModuleRights = useSelector(
    (state) => state.userAuth.userinfo.userModuleRights
  );
  const userModuleRights =
    rawModuleRights === null || rawModuleRights === undefined
      ? mainTabItemsList.reduce((acc, tab) => {
        acc[tab.navigationName] = true;
        return acc;
      }, {})
      : rawModuleRights;
  const { patients } = useSelector((state) => state.tabs);
  const { charges } = useSelector((state) => state.tabs);
  const [idlePopup, setIdlepopup] = useState(false);
  const { claimPopup } = useSelector((state) => state.popup);
  useShortcutKeys();
  const handleIdle = () => {
    setIdlepopup(true);
  }


  const idletimeout = useIdleTimeout({ onIdle: handleIdle, idleTime: userinfo.userTimeOut ?? 5, disabled: userinfo.isTimoutDisabled })
  const stay = () => {
    window.location.reload()
  }

  const handleMenuItemClick = (key, name, right, title, data) => {
    window.location.hash = `/`;
    if (name === "patients") {
      const activePatient = patients.find((patients) => patients.active);
      if (activePatient.id) {
        window.location.hash = `/?patientId=${activePatient.id}`;
      }
      else {
        window.location.hash = `/`;
      }
    } else if (name === "charges") {
      const visitID = charges?.find((a) => a)
      if (visitID?.subTabData?.visitId) {
        window.location.hash = `/?visitId=${visitID.subTabData?.visitId}`;
      }
      else {
        window.location.hash = `/`;
      }
    }
    dispatch(activeMainTab({ key, name, right, title, data }));
    // setActiveTab(key);
    // setTabsModal({ ...tabsModal, [name]: true });
  };

  const handleConfirmPractice = async () => {
    try {
      setLoader(true)
      const response = await api.get(`${process.env.REACT_APP_TC_AUTH}/api/Account/RefreshToken `,)
      dispatch(refreshToken(response.data.dataModel.token))
      const userInfo = await api.get(`${process.env.REACT_APP_TC_AUTH}/api/Account/GetUserInfo`);
      const { userModuleRights } = userInfo.data.dataModel.loginUserInfo
      const obj = {
        userInfo: {
          ...userInfo.data.dataModel.loginUserInfo,
          userModuleRights: lowercaseKeys(userModuleRights ?? {}),
        },
        practiceDetails: userInfo.data.dataModel.practiceDetails
      };

      dispatch(userAuthAction(obj));
      // const promises = DROP_DOWN_APIS.flatMap(apiType => apiType.apis.map(mainApi => api.get(`${apiType.type}/api${mainApi}`)));
      // const responses = await Promise.allSettled(promises);
      // responses.forEach(response => {
      //   if (response.status === 'fulfilled') {
      //     let apiUrl = response.value.config.url;
      //     let keyName = apiUrl.slice(apiUrl.lastIndexOf('/') + 1);
      //     let data = response.value.data.dataModel;
      //     keysAndData[keyName] = data;
      //   }
      // });
      // let keysAndData = {};
      // const typesOfServices = await api.get(`${process.env.REACT_APP_TC_COMMON}/api/TypeOfService/FindTypeOfServices`);// this API only run one time 
      // keysAndData["TypesOfServices"] = typesOfServices.data.dataModel;
      // dispatch(dataSliceAction(keysAndData));
    } catch (error) {
      ErrorHandlingMessage(error)
    } finally { setLoader(false) }
    dispatch(UpdatePracticePopupAction(false))
  }

  const handleCancelPractice = () => {
    dispatch(UpdatePracticePopupAction(false))
  }

  const handleAddNewClaim = (patient) => {
    dispatch(
      swtichTab({ parentName: "charges", subTabName: "claim", subTabData: { patientId: patient.id } })
    );
    dispatch(toggleClaimPopup(false))
  }


  // useEffect(() => {
  //   dispatch(resetTabs())
  // }, [userinfo.token, dispatch]);
  useEffect(() => {
    if (!mainTab) {
      let finalTabsModal = mainTabItemsList.map((item, index) => ({
        title: item.title,
        name: item.title.toLowerCase(),
        right: item.right,
        key: item.key,
      }));
      let tabsModal = {};
      finalTabsModal.forEach(
        (item, index) =>
        (tabsModal[item.name] =
          item.key === mainTabItemsList[CURRENT_TAB].key)
      );

      dispatch(activeMainTab(finalTabsModal[CURRENT_TAB]));
    }


  }, [mainTab, tabsModal, activeTab, dispatch]);
  useEffect(() => {
    // Reset scroll on tab change
    window.scrollTo({
      top: 0,
      behavior: "auto"
    });
  }, [activeTab]);
  const show = {
    transition: { ease: "easeOut", duration: 0.5 },
    opacity: 1,
  };

  const hide = {
    opacity: 0,
  };
  const [state, setState] = useState({
    activeDrags: 0,
    deltaPosition: {
      x: 0, y: 0
    },
    controlledPosition: {
      x: -400, y: 200
    }
  })
  const onStart = () => {
    setState({ ...state, activeDrags: ++state.activeDrags });
  };
  const onStop = () => {
    setState({ ...state, activeDrags: --state.activeDrags });
  };
  const dragHandlers = { onStart, onStop };
  const { deltaPosition, controlledPosition } = state;
  if (idlePopup) {
    return <IdleTimeoutpopup onYes={stay} />;
  }

  const hasAnyAccess = mainTabItemsList.some(
    (tab) => userModuleRights[tab.navigationName]
  );

  if (!hasAnyAccess) {
    return <NoAccessScreen />;
  }

  return (
    <>
      {/* {idlePopup && <IdleTimeoutpopup onYes={stay} />} */}

      {/* {loader && <FullPageLoader allowFullScreen />} */}
      {practicePopup && <ConfirmationPopup
        heading="Practice changed"
        subHeading="Practice has been changed. Do you want to Re login?"
        onConfirm={handleConfirmPractice}
        onCancel={handleCancelPractice}
        buttonTitle="Refresh"

      />}
      <Show when={claimPopup}>
        <CreateNewClaimPopup handleAddNew={handleAddNewClaim} onClose={() => dispatch(toggleClaimPopup(false))} />
      </Show>
      <div className="flex w-full h-screen overflow-hidden">
        <Sidebar mainTabs={mainTabItemsList} activeTab={activeTab} onItemClick={handleMenuItemClick} />
        <div className="flex flex-col flex-1 h-screen min-w-0 overflow-hidden main-content">
          <Header mainTabs={mainTabItemsList} activeTab={activeTab} onItemClick={handleMenuItemClick} sidebarToggle={sidebarToggle} setSidebarToggle={setSidebarToggle} />
          <HoverRevealScrollbarWrapper
            className="bg-[#F8FAFB] flex flex-col flex-1 min-h-0"
          >
            <div data-hover-scrollable="true" className="flex flex-col flex-1 min-h-0 px-4 pb-4 overflow-x-hidden overflow-y-auto">
              <RightsWrapper>
                <TabContent className="flex flex-col flex-1" activeTab={activeTab}>
                  <Suspense fallback={<FallBackLoader />}>
                    {mainTabItemsList
                      .filter((v) => tabsModal[v.navigationName] && v.Component)
                      .map((Item) => {
                        const Component = MainTabsComponent[Item.Component];
                        const isActive = activeTab === Item.key;
                        return (
                          <TabPane key={Item.key} id={Item.key} tabId={Item.key}>
                            <motion.div
                              initial={{ opacity: 0 }}
                              animate={isActive ? show : hide}
                              style={{ display: isActive ? "flex" : "none" }}
                              className="flex flex-col min-h-full"
                            >
                              <Component
                                parentKey={Item.key}
                                subTabs={Item.subTabs}
                                parentName={Item.name}
                              />
                            </motion.div>
                          </TabPane>
                        );
                      })}
                  </Suspense>
                </TabContent>
              </RightsWrapper>
            </div>

          </HoverRevealScrollbarWrapper>
          {/* <RocketDock  {...dragHandlers} mainTabs={MAIN_TAB_ITEMS} activeTab={activeTab} onItemClick={handleMenuItemClick} /> */}
        </div>
      </div>
    </>
  );
};

export default HomePage;
